import type { KeyDate } from "./types";

export const keyDates: KeyDate[] = [
  {
    title: "до 7 октября 2026 года",
    text: <>
      Выслать тезисы (требования по оформлению в Информационном письме) для включения в сборник конференции (<b>РИНЦ</b>). Материалы можно отправить на почту <span>conf.science-uriu@ranepa.ru</span>, регистрация будет доступна по ссылке
    </>,
    registrationLink: true,
    qr: true,
  },
  {
    title: "15–16 октября 2026 года",
    text: "Мероприятия конференции",
  },
  {
    title: "22–23 октября 2026 года",
    text: "Рассылка дипломов участников",
  },
  {
    title: "Декабрь 2026 года",
    text: <>
    Выпуск сборника материалов Конференции и размещение его в научной электронной библиотеке (<b>www.elibrary.ru</b>) с индексацией в наукометрической базе РИНЦ (Российский Индекс Научного Цитирования)</>,
  },
];
